import React, { Component } from "react";
import * as d3 from "d3";

class D3pie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: this.props.data,
    };
  }

  d3Pie = () => {
    var color = this.props.color;
    var data = this.state.chartData;
    var $this = "";
    var pwidth = document.getElementById("upper-right").clientWidth;
    const width = pwidth / 2,
      height = pwidth / 2,
      radius = width / 2 - 15;
    let innerradius = 0;

    if (this.props.chart == "speed") {
      $this = "#speedchart";
      innerradius = radius / 2;
    } else {
      $this = "#distancechart";
      innerradius = 0;
    }

    d3.select($this).selectAll("svg").remove();
    // var pwidth = document.getElementById("upper-right").clientWidth;
    // console.log("frm pie",pwidth)
    //  const width =pwidth / 2,
    //      height = pwidth / 2,
    //      radius = width /2

    var arc = d3.arc().outerRadius(radius).innerRadius(innerradius);

    data.forEach(function (d) {
      d.total = +d.value;
    });

    var pie = d3
      .pie()
      .sort(null)
      .value(function (d) {
        return d.total;
      });

    var svg = d3
      .select($this)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("class", "piechart")
      .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    var segments = svg.append("g").attr("class", "segments");

    var slices = segments
      .selectAll(".arc")
      .data(pie(data))
      .enter()
      .append("g")
      .attr("class", "arc");

    slices
      .append("path")
      .attr("d", arc)
      .attr("fill", function (d, i) {
        return color[i];
      })
      .transition()
      .attrTween("d", function (d) {
        var i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
        return function (t) {
          d.endAngle = i(t);
          return arc(d);
        };
      });
    slices
      .append("text")
      .attr("transform", function (d) {
        var c = arc.centroid(d);
        return "translate(" + c[0] + "," + c[1] + ")";
      })
      .text(function (d) {
        if (d.value > 1) {
          return d.value.toFixed(0) + "%";
        }
      })
      .style("fill", "#463339")
      .style("stroke", "#463339")
      .style("text-anchor", "middle")
      .style("font-width", "500")
      .style("font-size", 12);

    slices.on("mouseover", function (d) {
      //    this.props.onMouseMove(d.label);
      d3.select(this)
        .transition()
        .duration(700)
        .attr(
          "transform",
          "translate(" +
            arc.centroid(d)[0] / 8 +
            "," +
            arc.centroid(d)[1] / 8 +
            ")"
        );
    });

    slices.on("mouseout", function () {
      //  this.props.onMouseMove()
      d3.select(this)
        .transition()
        .duration(500)
        .attr("transform", "translate(0, 0)");
    });
  };

  componentDidMount() {
    this.d3Pie();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ chartData: nextProps.data });
  }
  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
      this.setState(
        {
          chartData: this.props.data || [],
        },
        function () {
          if (this.state.chartData.length > 0 && this.props.chart == "speed") {
            d3.select("#speedchart").html("");
            this.d3Pie();
          } else if (
            this.state.chartData.length > 0 &&
            this.props.chart == "distance"
          ) {
            d3.select("#distancechart").html("");
            this.d3Pie();
          }
        }
      );
    }
  }
  render() {
    return (
      <div style={{ height: "300px" }}>
        {this.props.chart == "speed" ? (
          <div id="speedchart"></div>
        ) : (
          <div id="distancechart"></div>
        )}
      </div>
    );
  }
}

export default D3pie;
